// extracted by mini-css-extract-plugin
module.exports = {"text":"stripe_info_text__1V-E3","text_wrapper":"stripe_info_text_wrapper__yRyPS","stripe_button":"stripe_info_stripe_button__13pm0","stripe_text":"stripe_info_stripe_text__3Ele6"};